import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { PresubscriptionResourceService } from './presubscription-resource.service';
import { IPresubscriptionListResult } from './presubscription.interface';
import { SeasonID } from '../season-resource/season.interface';

@Injectable({ providedIn: 'root' })
export class PresubscriptionsByNameResolver {
  private readonly presubscriptionResource = inject(
    PresubscriptionResourceService,
  );

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<IPresubscriptionListResult[]> {
    const id = route.queryParamMap.get('seasonId');
    return id
      ? this.presubscriptionResource.listAssigned(
          Number(id) as SeasonID,
          'name',
        )
      : of([]);
  }
}
